import { Component, OnInit, Input, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { Icon } from '../icon';

@Component({
  selector: 'app-dashboard-totalizer',
  templateUrl: './dashboard-totalizer.component.html',
  styleUrls: ['./dashboard-totalizer.component.scss']
})
export class DashboardTotalizerComponent {

  @Input() iconId: Icon;
  @Input() counter: number;
  @Input() label: string;
  @Input() caption: string;
  @Input() url: string;

  constructor(
    protected _injector: Injector
  ) { }

  navigate() {
    this._injector.get(Router).navigate([this.url])
  }
}
